import { render, staticRenderFns } from "./source-select-box.vue?vue&type=template&id=4d6215c6&scoped=true&"
import script from "./source-select-box.vue?vue&type=script&lang=js&"
export * from "./source-select-box.vue?vue&type=script&lang=js&"
import style0 from "./source-select-box.vue?vue&type=style&index=0&id=4d6215c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6215c6",
  null
  
)

export default component.exports